import { Helmet } from "react-helmet";
import PolicyLayout from "../sections/policy/policyLayout";
import termsNConditionsData from '../assets/data/termsNConditions.json';

const TermsNConditionsPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Terms of Service | AI, Gaming & Digital Solutions</title>
                <meta name="description" content="Review the code3x terms and conditions for AI, gaming, and digital services usage." />
                <meta name="keywords" content="code3x terms, terms and conditions, service policies, code3x legal, digital services terms" />
                <link rel="canonical" href="https://code3x.tech/terms-and-conditions" />
            </Helmet>

            <PolicyLayout data={termsNConditionsData}/>
        </>
    );
}

export default TermsNConditionsPage;